import { observable } from "mobx";
import AccountingDocumentsInventoryChangeActionRejectionReason from "./accountingDocumentsInventoryChangeActionRejectionReason";
import AccountingDocumentsInventoryChangeRestrictionLevel from "./accountingDocumentsInventoryChangeRestrictionLevel";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class AccountingDocumentsInventoryChangeActionResponse {
  @observable
  isAllowed!: boolean;

  @observable
  rejectionReason?: AccountingDocumentsInventoryChangeActionRejectionReason;

  @observable
  restrictionLevel?: AccountingDocumentsInventoryChangeRestrictionLevel;
}
